import React from "react";
import PropTypes from "prop-types";
import { IonLoading } from "@ionic/react";

export interface loaderProps {
  loader: any;
}
export const Loader: React.FC<loaderProps> = ({ loader }) => {
  return (
    <div>
      <IonLoading
        cssClass="my-custom-class"
        isOpen={loader}
        // onDidDismiss={() => setShowLoading(false)}
        message={"Please wait..."}
        duration={10000}
      />
    </div>
  );
};
